var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-collection-widget-edit"},[_c('remove-btn')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }